/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const tablePaginationSX: SxProps = {
	mt: 2,
	alignItems: 'center',
	justifyContent: { xs: 'center', sm: 'flex-end' },
};
